import React from 'react'
import { Card } from '@mui/material'

const StyledCard = ({ 
    children, 
    sx = {},
    padding = '16px',
    gap = '24px',
    ...props 
}) => {
    return (
        <Card
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                padding: padding,
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: gap,
                ...sx
            }}
            {...props}
        >
            {children}
        </Card>
    )
}

export default StyledCard 